<template>
    <div class="auth-wrapper">
        <div class="auth-box">
            <div class="lupus-logo">
                <img src="@/../assets/lupus-logo.png" height="80px" alt="Lupus Logo" />
            </div>
            <div class="auth-form-container">
                <div class="auth-input-container">
                    <b-form-group
                        id="fieldset-username"
                        label="Benutzername"
                        label-for="input-username"
                    >
                        <b-form-input
                            id="input-username"
                            v-model="user.username"
                            v-validate="'required'"
                            name="user"
                            type="text"
                            placeholder="Benutzername"
                            :state="checkState('user')"
                        />
                    </b-form-group>
                </div>
                <div class="auth-input-container">
                    <b-form-group
                        id="fieldset-password"
                        label="Passwort"
                        label-for="input-password"
                    >
                        <b-form-input
                            id="input-password"
                            v-model="user.password"
                            v-validate="'required'"
                            name="password"
                            type="password"
                            placeholder="Passwort"
                            :state="checkState('password')"
                        />
                    </b-form-group>
                </div>
                <div v-if="errors.any()" class="auth-error-message-container">
                    <span>{{ errors.all()[0] }}</span>
                </div>
            </div>
            <div class="auth-button-container">
                <div>
                    <button
                        class="btn btn-primary"
                        :disabled="
                            errors.any() || !fieldIsDirty('user') || !fieldIsDirty('password')
                        "
                        @click="login"
                    >
                        Anmelden
                    </button>
                </div>
                <router-link tag="div" to="login/forgot-password/" class="forgot-password">
                    Passwort vergessen?
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from "@/utils/EventBus";

export default {
    name: "Login",
    data() {
        return {
            user: {
                username: "",
                password: ""
            }
        };
    },
    methods: {
        async login() {
            this.$store
                .dispatch("login", {
                    username: this.user.username,
                    password: this.user.password
                })
                .then(() => {
                    EventBus.$emit("login-success");
                    this.$router.push("/");
                })
                .catch(e => {
                    console.error(e);
                    console.log(this.errors);
                    //EventBus.$emit("login-failed");
                });
        }
    }
};
</script>

<style scoped lang="scss">
@import "login.css";
</style>
